import React from 'react';
import { motion } from 'framer-motion';

interface AnimatedSectionProps {
    children: React.ReactNode;
    className?: string;
    id?: string;
    isHero?: boolean;
    scaleStart?: number;
    delay?: number;
    duration?: number;
    amount?: 'some' | 'all' | number;
    margin?: string;
    style?: React.CSSProperties;
    [key: string]: any;
}

/**
 * AnimatedSection:
 * Membungkus elemen section halaman publik dengan efek animasi Zoom-In & Fade yang halus,
 * persis seperti visual section atas di Sholehah & Jofisah.
 *
 * Props:
 * - isHero: boolean (jika true, langsung animasi saat render; jika false, animasi saat scroll masuk viewport)
 * - scaleStart: number (default: 0.96)
 * - delay: number (default: 0)
 * - duration: number (default: 0.8)
 * - amount: 'some' | 'all' | number (default: 'some', agar section tinggi di mobile tidak blank)
 */
export const AnimatedSection: React.FC<AnimatedSectionProps> = ({
    children,
    className = '',
    id,
    isHero = false,
    scaleStart = 0.96,
    delay = 0,
    duration = 0.8,
    amount = 'some',
    margin = '100px 0px 0px 0px',
    style,
    ...rest
}) => {
    return (
        <motion.section
            id={id}
            initial={{ opacity: 0, scale: scaleStart, y: 20 }}
            animate={isHero ? { opacity: 1, scale: 1, y: 0 } : undefined}
            whileInView={!isHero ? { opacity: 1, scale: 1, y: 0 } : undefined}
            viewport={!isHero ? { once: true, amount, margin } : undefined}
            transition={{
                duration,
                delay,
                ease: [0.16, 1, 0.3, 1]
            }}
            className={className}
            style={style}
            {...rest}
        >
            {children}
        </motion.section>
    );
};

export const AnimatedDiv: React.FC<AnimatedSectionProps> = ({
    children,
    className = '',
    id,
    isHero = false,
    scaleStart = 0.96,
    delay = 0,
    duration = 0.8,
    amount = 'some',
    margin = '100px 0px 0px 0px',
    style,
    ...rest
}) => {
    return (
        <motion.div
            id={id}
            initial={{ opacity: 0, scale: scaleStart, y: 20 }}
            animate={isHero ? { opacity: 1, scale: 1, y: 0 } : undefined}
            whileInView={!isHero ? { opacity: 1, scale: 1, y: 0 } : undefined}
            viewport={!isHero ? { once: true, amount, margin } : undefined}
            transition={{
                duration,
                delay,
                ease: [0.16, 1, 0.3, 1]
            }}
            className={className}
            style={style}
            {...rest}
        >
            {children}
        </motion.div>
    );
};

export default AnimatedSection;
